function addUtmParamsToLinksAndPageNavigators(verifiedUtm, LinkorNav) {
  if (verifiedUtm !== "") {
    return LinkorNav + "?" + verifiedUtm;
  } else {
    return LinkorNav;
  }
}

function addUtmParamsToSectionNavigators(verifiedUtm, sectionId) {
  if (verifiedUtm !== "") {
    return "?" + verifiedUtm + sectionId;
  } else {
    return sectionId;
  }
}

export {
  addUtmParamsToLinksAndPageNavigators,
  addUtmParamsToSectionNavigators,
};
